module.exports = __webpack_public_path__ + "img/With_Blue.508aa99a.svg";